"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgUploadUtil = exports.defaultStrategy = exports.decryptToken = exports.getSignature = void 0;
var axios_1 = require("axios");
var SparkMD5 = require("spark-md5");
var CryptoJS = require("crypto-js");
var uuid_1 = require("uuid");
var types_1 = require("./types");
var package_json_1 = require("../package.json");
var utils_1 = require("./utils");
var isTimeout = function (error) {
    return error.message.includes('timeout') || error.code === 'ECONNABORTED';
};
var randomStr = function (len) {
    len = len || 32;
    var base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var res = '';
    for (var i = 0; i < len; i++) {
        res += base[Math.floor(Math.random() * base.length)];
    }
    return res;
};
var getSignature = function (reqId, biz) {
    var ts = Date.now().toString().substr(0, 10);
    var _randomStr = randomStr(6);
    var md5 = SparkMD5.hash(_randomStr + '@' + reqId + '@' + biz + '@shopee@' + ts);
    return _randomStr + '-' + md5 + '-' + ts;
};
exports.getSignature = getSignature;
var decryptToken = function (token, reqId) {
    var iv = '1234567887654321';
    var result = CryptoJS.AES.decrypt(token, CryptoJS.enc.Utf8.parse(reqId), {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return result.toString(CryptoJS.enc.Utf8);
};
exports.decryptToken = decryptToken;
exports.defaultStrategy = {
    ver: 1,
    interval: 7200000,
    ttl: 9000000,
    pull_time: 1635429656,
    api_timeout: 4000,
    configs: {
        100: {
            compress: {
                compress_type: 0,
                quality: 100,
                scale: 1
            },
            upload: {
                slice: 1024000,
                retry_count: 2,
                backoff_time: 50,
                default_img_count: 3,
                concurrency: 3
            },
            endpoint: {
                doamin_rules: {},
                default_suffix: '',
                extend_suffix: ''
            }
        }
    }
};
var ImgUploadUtil = /** @class */ (function () {
    function ImgUploadUtil(options) {
        this.options = options;
    }
    ImgUploadUtil.prototype.preupload = function (params) {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var commonBody, startTime, res, data, error_1, actionId;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        commonBody = this.genCommonBody();
                        startTime = Date.now();
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, params.axiosInstance.post("https://api.mms." + types_1.IEnvDomain[this.options.env] + ".shopee." + types_1.ICountryDomain[this.options.country] + "/uploadapi/api/v1/image/preupload", {
                                _header: commonBody,
                                count: params.imgCount
                            })];
                    case 2:
                        res = _f.sent();
                        data = res.data.data;
                        data.services = data.services.map(function (item, idx) { return (__assign(__assign({}, item), { token: exports.decryptToken(item.token, commonBody.request_id), index: idx })); });
                        (_a = this.options.report) === null || _a === void 0 ? void 0 : _a.ImgPreuploadEvent({
                            actionId: 0,
                            serviceLen: data.services.length,
                            firstServiceId: data.services[0].service_id,
                            imgIdsLen: data.img_ids.length,
                            cost: Date.now() - startTime,
                            strategyVer: params.strategyVer
                        });
                        return [2 /*return*/, data];
                    case 3:
                        error_1 = _f.sent();
                        actionId = (_d = (_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : 500;
                        if (isTimeout(error_1))
                            actionId = 3001;
                        (_e = this.options.report) === null || _e === void 0 ? void 0 : _e.ImgPreuploadEvent({
                            actionId: actionId,
                            cost: Date.now() - startTime,
                            strategyVer: params.strategyVer
                        });
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ImgUploadUtil.prototype.getStrategy = function (key) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var $, _strategy, startTime, res, data, error_2, strategyCache, actionId;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        $ = axios_1.default.create({
                            adapter: utils_1.retryAdapterEnhancer(axios_1.default.defaults.adapter, {
                                times: 3,
                                delay: 0
                            })
                        });
                        _strategy = JSON.parse(localStorage.getItem(key));
                        if (!(!_strategy || Date.now() - _strategy.pull_time * 1000 > _strategy.ttl)) return [3 /*break*/, 5];
                        startTime = Date.now();
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, $.post("https://endpoint.mms." + types_1.IEnvDomain[this.options.env] + ".shopee." + types_1.ICountryDomain[this.options.country] + "/api/v1/strategy/img", {
                                _header: this.genCommonBody()
                            })];
                    case 2:
                        res = _d.sent();
                        data = res.data.data;
                        localStorage.setItem(key, JSON.stringify(data));
                        this.options.report
                            .ImgGetStrategyEvent({
                            actionId: 0,
                            ver: data.ver,
                            cost: Date.now() - startTime
                        })
                            .report();
                        return [2 /*return*/, data];
                    case 3:
                        error_2 = _d.sent();
                        strategyCache = _strategy || JSON.parse(JSON.stringify(exports.defaultStrategy));
                        strategyCache.pull_time = Math.trunc(Date.now() / 1000);
                        localStorage.setItem(key, JSON.stringify(strategyCache));
                        actionId = (_c = (_b = (_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : 500;
                        if (isTimeout(error_2))
                            actionId = 1001;
                        this.options.report
                            .ImgGetStrategyEvent({
                            actionId: actionId,
                            cost: Date.now() - startTime
                        })
                            .report();
                        return [2 /*return*/, exports.defaultStrategy];
                    case 4: return [3 /*break*/, 6];
                    case 5: return [2 /*return*/, _strategy];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ImgUploadUtil.prototype.notify = function (params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __awaiter(this, void 0, void 0, function () {
            var startTime, code, error_3, actionId;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        startTime = Date.now();
                        _j.label = 1;
                    case 1:
                        _j.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, params.axiosInstance.post("https://api.mms." + types_1.IEnvDomain[this.options.env] + ".shopee." + types_1.ICountryDomain[this.options.country] + "/uploadapi/api/v1/image/notify", {
                                _header: this.genCommonBody(),
                                service_id: params.serviceId,
                                img_id: params.imgId,
                                url: params.url,
                                fsize: params.fsize,
                                finish_time: params.finishTime
                            }, {
                                headers: {
                                    Authorization: params.token
                                }
                            })];
                    case 2:
                        code = (_j.sent()).data.code;
                        (_a = this.options.report) === null || _a === void 0 ? void 0 : _a.ImgNotifyEvent({
                            actionId: 0,
                            serviceId: params.serviceId,
                            imgid: params.imgId,
                            code: code,
                            cost: Date.now() - startTime,
                            strategyVer: params.strategyVer
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _j.sent();
                        actionId = (_d = (_c = (_b = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.code) !== null && _d !== void 0 ? _d : 500;
                        if (isTimeout(error_3))
                            actionId = 5001;
                        (_e = this.options.report) === null || _e === void 0 ? void 0 : _e.ImgNotifyEvent({
                            actionId: actionId,
                            serviceId: params.serviceId,
                            imgid: params.imgId,
                            code: (_h = (_g = (_f = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.code) !== null && _h !== void 0 ? _h : 500,
                            cost: Date.now() - startTime,
                            strategyVer: params.strategyVer
                        });
                        throw error_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ImgUploadUtil.prototype.genCommonBody = function () {
        var requestId = uuid_1.v4().replace(/-/g, '');
        return {
            version: 1,
            sign: exports.getSignature(requestId, this.options.biz),
            biz: this.options.biz,
            app_version: 'uss-' + package_json_1.version,
            sdk_version: 'uss-' + package_json_1.version,
            os_type: 2,
            request_id: requestId,
            device_model: navigator.userAgent,
            client_region: this.options.country,
            uid: this.options.uid
        };
    };
    return ImgUploadUtil;
}());
exports.ImgUploadUtil = ImgUploadUtil;
